// Keerthanadoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import keerthanadoc from './../../../../assets/images/Doctorsimages/keerthanadoc.png' // Ensure this path/image exists
import favicon from "./../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'

const Keerthanadoc = () => {
  const navigate = useNavigate(); 
  
  useEffect(() => {
    document.title = "Dr. M. Keerthana | Expert Homeopathy, Cosmetology & Trichology Consultant";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. M. Keerthana (BHMS, PGDCC), a specialist in Homeopathy, Clinical Cosmetology, and Trichology. Combining internal healing with advanced external aesthetic care for skin and hair."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best homeopathy doctor, clinical cosmetologist, trichologist, hair fall treatment, skin rejuvenation specialist, Dr. M. Keerthana, homeopathy for skin and hair, PGDCC doctor, hair regrowth specialist, holistic aesthetic doctor, Sivaraj Homeopathy Medical College alumni, internal healing for external beauty, consultant trichologist"
      );
    }

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-m-keerthana-homeopathy-cosmetology");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-m-keerthana-homeopathy-cosmetology");
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');

    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => { img.style.opacity = '1'; });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        backgroundColor: '#ffffff',
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr.M.Keerthana_Profile.pdf');
      }).catch(error => {
        console.error('Error generating PDF:', error);
        container.classList.remove('veenadoc-pdf-mode');
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. M. Keerthana</span>
                  <span className="veenadoc-title-credentials">(BHMS, PGDCC)</span>
                  <span className="veenadoc-title-location">Homeopathy, Cosmetology & Trichology</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Bridging the gap between internal healing and aesthetic excellence. Dr. Keerthana specializes in 
                    merging the science of Homeopathy with advanced Clinical Cosmetology and Trichology for 
                    comprehensive skin and hair care.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={keerthanadoc} alt="Professional profile of Dr. M. Keerthana (BHMS, PGDCC)" className="veenadoc-doctor-image" title='Dr. M. Keerthana – Consultant in Homeopathy, Cosmetology & Trichology' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                <div className="veenadoc-article-block">
                  <h2>A Dual Approach to Beauty and Wellness</h2>
                  <p>
                    Dr. M. Keerthana (BHMS, PGDCC) is a distinguished Consultant who has pioneered a unique ability to blend 
                    traditional internal healing with modern aesthetic science. With a specialized focus on Trichology and 
                    Clinical Cosmetology, she provides a comprehensive approach to beauty and wellness that begins at the cellular level.
                  </p>
                  <p>
                    Dr. Keerthana earned her medical degree from the prestigious <strong>Sivaraj Homeopathy Medical College and Research Institute</strong>, Salem. 
                    To further her expertise in aesthetics, she completed advanced training at the <strong>Cosmocareer Academy in Pune</strong>, 
                    earning a Post Graduate Diploma in Clinical Cosmetology (PGDCC) and Trichology.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS, PGDCC (Clinical Cosmetology & Trichology)</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">3+ Years of Clinical Expertise</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Philosophy:</span>
                      <span className="veenadoc-info-value">Internal Healing for External Beauty</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Education:</span>
                      <span className="veenadoc-info-value">Sivaraj Homeopathy Medical College</span>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Medical Foundation & Clinical Experience</h2>
                  <p>
                    With three years of diverse clinical experience, including a significant tenure as a Duty Medical Officer at 
                    <strong> Kavin Eniyan Cardiac and Women Hospital</strong> in Salem, Dr. Keerthana has developed a keen eye for 
                    diagnosing complex health issues. 
                  </p>
                  <p>
                    This background in acute and systemic care allows her to approach cosmetology with a medical depth that goes 
                    beyond surface-level treatments. Whether she is treating a chronic skin condition or addressing hair thinning, 
                    her medical foundation ensures that every aesthetic recommendation is safe, scientific, and personalized.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Regrowth</h2>
                  <p>
                    As a specialist in Trichology, Dr. Keerthana is highly sought after for her expertise in hair and scalp health. 
                    She understands that hair loss is often linked to nutrition, stress, and hormonal shifts.
                  </p>
                  <p>
                    Her treatment protocols involve identifying these internal triggers through homeopathy while simultaneously 
                    utilizing modern trichological tools to stimulate hair regrowth and improve scalp vitality. This dual-action 
                    method has made her a preferred consultant for patients seeking natural yet effective solutions for hair fall, 
                    dandruff, and premature thinning.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Clinical Cosmetology Expertise</h2>
                  <p>In the realm of Clinical Cosmetology, Dr. Keerthana specializes in skin rejuvenation and the management of chronic dermatological concerns:</p>
                  <ul>
                    <li><strong>Holistic Skin Rejuvenation:</strong> Treating acne, pigmentation, and scars by balancing the body’s internal chemistry.</li>
                    <li><strong>Advanced Trichology:</strong> Specialized protocols for alopecia and thinning hair using homeopathic constitutional remedies.</li>
                    <li><strong>Anti-Aging & Glow Therapies:</strong> Enhancing skin elasticity and radiance through treatments that support natural collagen production.</li>
                    <li><strong>Lifestyle & Nutritional Counseling:</strong> Integrating diet and wellness habits to sustain long-term aesthetic results.</li>
                  </ul>
                </div>

                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Your Partner in Holistic Beauty</h2>
                  <p>
                    Choosing Dr. Keerthana means opting for a medical professional who values the integrity of your health as much 
                    as the quality of your results. Her mission is to empower individuals to look and feel their best by 
                    harmonizing the body's internal vitality with external aesthetic excellence.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her Professional Mantra:</strong> "I treat from within and enhance results on the outside."
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">✨</div>
                    <blockquote style={{ fontSize: '1.1rem' }}>
                      "True aesthetic beauty—glowing skin and healthy hair—is a reflection of internal physiological balance."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. M. Keerthana's Philosophy</p>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Treatment Focus</h3>
                  <ul className="veenadoc-services-list">
                    <li>💇‍♀️ Hair Fall & Thinning</li>
                    <li>🧖‍♀️ Skin Rejuvenation</li>
                    <li>🎯 Acne & Scar Management</li>
                    <li>🧬 Constitutional Homeopathy</li>
                    <li>🧴 Scalp Vitality</li>
                    <li>🥗 Nutritional Counseling</li>
                  </ul>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience the synergy of medical homeopathy and advanced cosmetology.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button className="veenadoc-sidebar-btn-secondary" onClick={() => navigate('/bookconsultation')}>
                    <span>📅</span>
                    <span>Get Free Assessment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download Dr. Keerthana's Profile as PDF
        </button>
      </div>
    </>
  )
}

export default Keerthanadoc
